import { render, staticRenderFns } from "./TableOrderTotal.vue?vue&type=template&id=191e8bde&scoped=true"
import script from "./TableOrderTotal.vue?vue&type=script&lang=js"
export * from "./TableOrderTotal.vue?vue&type=script&lang=js"
import style0 from "./TableOrderTotal.vue?vue&type=style&index=0&id=191e8bde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191e8bde",
  null
  
)

export default component.exports